import { Model } from '@shared/models/model';
import { Expose } from 'class-transformer';

export class ShipmentHistoryUpdate extends Model {
  @Expose()
  newDate: number;

  @Expose()
  updatedBy: number;

  @Expose()
  updatedByName: string;

  @Expose()
  previousDate: number;
}
